import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DatePicker } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputOtpModule } from 'primeng/inputotp';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { TextareaModule } from 'primeng/textarea';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';

export const PRIME_FORM_MODULES = [
  FloatLabelModule,
  InputTextModule,
  PasswordModule,
  CheckboxModule,
  RadioButtonModule,
  DatePicker,
  InputNumberModule,
  KeyFilterModule,
  ToggleSwitchModule,
  InputOtpModule,
  SelectModule,
  MultiSelectModule,
  TextareaModule,
  IconFieldModule,
  InputIconModule,
  ButtonModule,
  SelectButtonModule
];
